import React, { type ReactNode } from 'react';
import { EMAIL_BUILDER_DOM_ID_PREFIX, useStableDomId } from '../../useStableDomId';
import { FieldLabel } from './FieldLabel';
import type { FieldReset } from '../../domain/baselines';

export function PropertyRow({
  label,
  children,
  htmlFor,
  reset,
}: {
  label: string;
  children: ReactNode;
  htmlFor?: string;
  reset?: FieldReset;
}) {
  const labelId = useStableDomId(EMAIL_BUILDER_DOM_ID_PREFIX);
  const groupLabelId = htmlFor ? undefined : labelId;

  return (
    <div
      className={"email-builder-settings-field"}
      role={groupLabelId ? 'group' : undefined}
      aria-labelledby={groupLabelId}>
      {htmlFor ? (
        <FieldLabel label={label} htmlFor={htmlFor} reset={reset} />
      ) : (
        <FieldLabel label={label} id={labelId} reset={reset} />
      )}
      <div className={"email-builder-settings-field-control"}>{children}</div>
    </div>
  );
}
